import { render, staticRenderFns } from "./object-mapper.vue?vue&type=template&id=f580cf2e&scoped=true&"
import script from "./object-mapper.vue?vue&type=script&lang=js&"
export * from "./object-mapper.vue?vue&type=script&lang=js&"
import style0 from "./object-mapper.vue?vue&type=style&index=0&id=f580cf2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f580cf2e",
  null
  
)

export default component.exports